import FundService from 'src/modules/fund/fundService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'FUND_FORM';

const fundFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: fundFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await FundService.find(id);
      }

      dispatch({
        type: fundFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: fundFormActions.INIT_ERROR,
      });

      getHistory().push('/fund');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: fundFormActions.CREATE_STARTED,
      });

      await FundService.create(values);

      dispatch({
        type: fundFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.fund.create.success'),
      );

      getHistory().push('/fund');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: fundFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: fundFormActions.UPDATE_STARTED,
      });

      await FundService.update(id, values);

      dispatch({
        type: fundFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.fund.update.success'),
      );

      getHistory().push('/fund');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: fundFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default fundFormActions;
